import { CaseDocument } from "./CaseDocument";

export interface PageMetadata {
  size: number;
  number: number;
  totalElements: number;
  totalPages: number;
}

/**
 * Normalizes paginated responses to a consistent {@link PageMetadata}. The backend
 * returns page metadata either nested under `page` (e.g. stage) or flattened at the
 * top level as a Spring Data `Page` (e.g. prod). This supports both shapes.
 */
export function toPageMetadata(data: any): PageMetadata {
  const p = data && typeof data.page === "object" && data.page !== null ? data.page : data;
  return {
    size: p?.size ?? 0,
    number: p?.number ?? 0,
    totalElements: p?.totalElements ?? 0,
    totalPages: p?.totalPages ?? 0,
  };
}

export interface DocumentList {
  content: CaseDocument[];
  page: PageMetadata;
}

export interface DocumentListSettings {
  name?: string;
  fromDate?: string; // https://en.wikipedia.org/wiki/ISO_8601
  toDate?: string; //// 2021-05-04T20:42:53
  type?: string;
  creator?: string;
  page?: number;
  size?: number;
}
export type APIParams = {
  results: number;
  page?: number;
  sortBy?: string;
  sortOrder?: string;
  [key: string]: any;
};
